require('../../../assets/lib/jquery/jquery-ui-1.13.2.min.js');
require('../../../assets/scripts/common/polyfills.js');
require('../../../assets/scripts/common/jv.i18n.js');
require('../../../assets/scripts/common/jv.TextUtil.js');
require('../../../assets/scripts/common/jv.EmployeeSelect.js');
require('../../../assets/scripts/common/jv.TemplateLoader.js');
require('../../../assets/scripts/common/directives/jv.FormTemplate.js');
require('../../../assets/scripts/common/directives/jv.MessageTemplate.js');
require('../../../assets/scripts/common/jv.Modal.js');
require('../../../assets/scripts/common/jv.MessageBar.js');
require('../../../assets/scripts/common/directives/jv.AjaxSelect.js');
require('../../../assets/scripts/source/jv.source.modal-adapter.service.js');
require('../../../assets/scripts/source/campaigns/V2/JV.Campaigns.select2services.js');
require('../../../assets/scripts/source/campaigns/V2/JV.CampaignConstants.js');
require('../../../assets/scripts/source/campaigns/V2/JV.CampaignModal.js');
require('../../../assets/lib/js/angularmodule/angdirective.js');
require('../../../assets/scripts/common/jv.Filters.webpack.js');
require('../../../assets/lib/js/angularmodule/angservice.js');
require('../../../assets/lib/js/JV.FriendWidget_js_upgrade.js');
require('../../../assets/lib/ngStorage/ngStorage.min.js');
require('../../../assets/scripts/common/directives/jv.HideOnBlur.js');
require('../../../assets/scripts/source/campaigns/V2/JV.CampaignService.js');
require('../../../assets/scripts/source/campaigns/V2/JV.CampaignList.js');
require('../../../assets/scripts/common/jv.Jobvite.Urls.js');
require('../../../assets/scripts/source/contacts/JV.ContactDetails.svc.js');
require('../../../assets/lib/angularJS-NES/angular-sanitize.min.js');